import { emptyRules, } from "openchat-shared";
// all of this stuff gets updated together so the whole thing will be a store, but the individual bits don't need to be
// I *think*
export class CommunityDetailsState {
    communityId;
    userGroups;
    members;
    blockedUsers;
    lapsedMembers;
    invitedUsers;
    referrals;
    bots;
    rules;
    constructor(communityId, userGroups, members, blockedUsers, lapsedMembers, invitedUsers, referrals, bots, rules = emptyRules()) {
        this.communityId = communityId;
        this.userGroups = userGroups;
        this.members = members;
        this.blockedUsers = blockedUsers;
        this.lapsedMembers = lapsedMembers;
        this.invitedUsers = invitedUsers;
        this.referrals = referrals;
        this.bots = bots;
        this.rules = rules;
    }
}
